export const ARCHIVE_SEARCH_MODES = Object.freeze({
  LEXICAL: "lexical",
  SEMANTIC: "semantic",
  SEMANTIC_STALE: "semantic_stale",
  LEXICAL_ONLY: "lexical_only",
});

export const ARCHIVE_SEARCH_FALLBACK_REASONS = Object.freeze({
  CORPUS_UNAVAILABLE: "corpus_unavailable",
  RATE_LIMITED: "rate_limited",
  DAILY_BUDGET_EXCEEDED: "daily_budget_exceeded",
  EMBEDDING_REQUEST_FAILED: "embedding_request_failed",
  SEMANTIC_STALE: "semantic_stale",
  SEMANTIC_UNAVAILABLE: "semantic_unavailable",
});

export const ARCHIVE_SEARCH_SORTS = Object.freeze({
  RELEVANCE: "relevance",
  NEWEST: "newest",
  RATING: "rating",
});

export const ARCHIVE_SEARCH_URL_MODES = Object.freeze({
  LEXICAL: ARCHIVE_SEARCH_MODES.LEXICAL,
  SEMANTIC: ARCHIVE_SEARCH_MODES.SEMANTIC,
});

export function isSemanticMode(mode = "") {
  return mode === ARCHIVE_SEARCH_MODES.SEMANTIC || mode === ARCHIVE_SEARCH_MODES.SEMANTIC_STALE;
}

export function isFallbackMode(mode = "") {
  return mode === ARCHIVE_SEARCH_MODES.LEXICAL_ONLY;
}

export function isStaleSemanticReason(reason = "") {
  return reason === ARCHIVE_SEARCH_FALLBACK_REASONS.SEMANTIC_STALE;
}
